export interface TrackingResponse {
  actualDeliveryDate: Date;
  carrierCode: string;
  carrierDetailCode: null;
  carrierId: number;
  carrierStatusCode: string;
  carrierStatusDescription: StatusDescription;
  estimatedDeliveryDate: null;
  events: Event[];
  exceptionDescription: null;
  shipDate: Date;
  statusCode: string;
  statusDescription: StatusDescription;
  trackingNumber: string;
  trackingUrl: string;
}

export interface TrackingResponseError {
  errors: {
    message: string;
  }[];
}

export const isTrackingResponseError = (
  data: TrackingResponse | TrackingResponseError
): data is TrackingResponseError => {
  return "errors" in data;
};

export enum StatusDescription {
  Accepted = "Accepted",
  Delivered = "Delivered",
  InTransit = "In Transit",
}

export interface Event {
  carrier_detail_code: null;
  carrier_occurred_at: Date;
  carrier_status_code: string;
  carrier_status_description: string;
  city_locality: null | string;
  company_name: null;
  country_code: string;
  description: string;
  event_code: string;
  latitude: number;
  longitude: number;
  occurred_at: Date;
  postal_code: string;
  signer: null | string;
  state_province: null | string;
  status_code: string;
  status_description: StatusDescription;
}
